<template>
	<!-- 单行输入框 -->
	<div @click="setEditIndex(index)" class="Blank">
		<p v-if="isBankViewTest" class="my-bank-tag">
			{{question.questionsTypeId == 2 ? $t('main.cellPhoneNumber') : (
				question.questionsTypeId == 3 ? $t('main.SingleLineInputBox') : (
					question.questionsTypeId == 4 ? $t('main.MultilineInputBox') : $t('main.fillInTheBlanks')
				)
			)}}
		</p>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ question.quesIndex + 1 }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
				
        		<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				
				<TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
                    :isCitable="true"
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-top: 12px !important">
			<div>  
				<el-row>
					<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class=" item_container_title" style="margin-left: 50px; margin-bottom: 24px">
						<!-- <el-input
							disabled
							type="textarea"
							resize="none"
							v-model="question.placeholder"
							:rows="question.inputHeight == $t('main.big') ? 3 : (question.inputHeight == $t('main.middle') ? 2 : 1)"
						>
						</el-input> -->
						<div v-if="question.inputHeight" class="imitation-form-input-text imitation-form-small" 
							:style="{height: question.inputHeight == '小' ? '32px' : (question.inputHeight == '中' ? '51px' : '70px')}">
						</div>
						<div v-if="question.cutType" class="imitation-form-input-text imitation-form-small" 
							:style="{height: question.cutType == 1 ? '32px' : '70px'}">
						</div>
					</el-col>
				</el-row>
			</div>
		</el-row>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import OperateWrap from "./collectToBank/operateaWrap.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
export default {
	components: {
    	TitleEditor,
		OperateWrap
	},
	data() {
		return {
		};
	},
	props: {
		question: {},
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		...mapState(['activeInputId']),
	},
	created(){
	},
	methods: {
		...mapActions(['setActiveInput']),
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
	},
	created() {}
};
</script>
<style scoped lang="scss">
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle {
	cursor: move;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
</style>
